import React, { useState } from 'react';
import axios from 'axios';
import {
    MDBContainer,
    MDBCard,
    MDBCardBody,
    MDBCardTitle,
    MDBInput,
    MDBBtn
} from 'mdb-react-ui-kit';
import {useHistory, useParams} from 'react-router-dom';

function MyApplications() {
    const [email, setEmail] = useState('');
    const { eventName } = useParams();
    const history = useHistory();

    const fetchApplications = async () => {
        if (!email) {
            alert('이메일을 입력해주세요.');
            return;
        }

        try {
            const decodedEventName = eventName.replaceAll('_', ' ');
            const response = await axios.post(`${process.env.REACT_APP_API_REAL_URL}/public/qr-event-participant/target`, {
                event_name: decodedEventName,
                email: email
            });

            // 조회된 참가자 정보를 ParticipantResponse로 전달하며 이동
            history.push(`/qr-event-participant-my-view`, {
                    uuid: response.data.privateCode,
                    name: response.data.name,
                    affiliation: response.data.affiliation,
                    contactNumber: response.data.contactNumber,
                    email: response.data.email,
                    eventName: eventName
            });
        } catch (error) {
            console.error('등록되지 않는 참가자이거나 존재하지 않는 행사입니다.', error);
            alert('등록되지 않는 참가자이거나 존재하지 않는 행사입니다.');
        }
    };

    return (
        <MDBContainer className='d-flex justify-content-center align-items-center' style={{ minHeight: '100vh', padding: '20px', backgroundColor: '#f5f5f5' }}>
            <MDBCard style={{ maxWidth: '400px', width: '100%', borderRadius: '15px', boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)' }}>
                <MDBCardBody>
                    <MDBCardTitle className="text-center mb-4" style={{ fontWeight: 'bold', color: '#4CAF50' }}>나의 신청 내역 조회</MDBCardTitle>
                    <MDBInput
                        wrapperClass='mb-4'
                        label='이메일'
                        type='email'
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                    <MDBBtn color="primary" onClick={fetchApplications} className="w-100">
                        신청 내역 조회
                    </MDBBtn>
                </MDBCardBody>
            </MDBCard>
        </MDBContainer>
    );
}

export default MyApplications;